/*
 * @Author: 秦少卫
 * @Date: 2024-04-24 14:07:06
 * @LastEditors: 秦少卫
 * @LastEditTime: 2024-06-14 16:17:41
 * @Description: 用户接口登录
 */

import axios from 'axios';
import md5 from 'js-md5';
const baseURL = import.meta.env.APP_APIHOST;
import { useUserStore } from '@/components/loginUser/useUserStore';

const instance = axios.create({ baseURL });

instance.interceptors.request.use(async function (config) {
  let time = new Date().getTime();
  const key = '492354skddejdfnv@#%#$%sodoew';
  config.headers['time'] = time;
  config.headers['sign'] = md5(time + '&&' + key);
  await useUserStore().expireToken();
  return config;
});

const tokenKey = 'token';
// 获取token
export const getToken = () => localStorage.getItem(tokenKey);
// 设置token
export const setToken = (token: string) => localStorage.setItem(tokenKey, token);
// 公共模版
export const templatePublicList = (data: any) =>
  instance.get('/design/template/templatePublicList', data);

// 私有模版
export const templatePrivateList = (data: any) =>
  instance.get(`/design/template/templatePrivateList?${data}`);

// 上传图片
export const upload = (data: any) => instance.post('/design/common/upload', data);

// 保存模版
export const save = (data: any) => instance.post('/design/template/save', data);

// 删除接口
export const deleteTemplate = (data: any) => instance.delete(`/design/template/delete?${data}`);

// 获取模版
export const detailById = (data: any) => instance.get(`/design/template/detailById?${data}`);
